<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!-- {{employee_list}} {{leave_transaction_report_list}} -->
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leave Transaction Report</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense justify="center">
        <v-col cols="12" sm="12" md="3">
          <b> Leave Academic Year</b>
          <v-autocomplete v-model="editedItem.leaveacademicyear" :items="leave_academic_year_list" item-text="ay"
            item-value="id" label="Academic year" single-line rounded outlined dense return-object></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="12" md="3">
          <b>Leave Type</b>
          <v-autocomplete v-model="editedItem.leavetype" :items="leave_type_list" label="Leave Type" item-text="type"
            item-value="id" single-line rounded outlined dense></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="12" md="3">
          <b>Employee</b>
          <v-autocomplete v-model="editedItem.employee" :items="employee_list" item-text="name" item-value="id"
            label="Employee" single-line rounded outlined dense></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="12" sm="12" md="3">
          <b> Approval Status</b>
          <v-autocomplete v-model="editedItem.leaveapprovalstatus" :items="leave_approval_status_list"
            item-text="status" item-value="id" label="Approval Status" single-line rounded outlined dense
            multiple></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="12" md="3">
          <b>From Date (Inclusive)</b>
          <input id="datePickerId" type="date" v-model="editedItem.fromdate" />

          <!-- <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="editedItem.fromdate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              From Date:-
              <v-text-field
                rounded
                outlined
                dense
                v-model="editedItem.fromdate"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="[(v) => !!v || 'required']"
                persistent-hint
                hint="YYYY/MM/DD FORMAT"
              ></v-text-field>
            </template>
            <v-date-picker v-model="editedItem.fromdate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(editedItem.fromdate)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu> -->
        </v-col>

        <v-col cols="12" sm="12" md="3">
          <b>To date (Inclusive)</b>
          <input id="datePickerId" type="date" v-model="editedItem.todate" />
          <!-- <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :return-value.sync="editedItem.todate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              To Date:-
              <v-text-field
                rounded
                outlined
                dense
                v-model="editedItem.todate"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="[(v) => !!v || 'required']"
                persistent-hint
                hint="YYYY/MM/DD FORMAT"
              ></v-text-field>
            </template>
            <v-date-picker v-model="editedItem.todate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu1 = false">Cancel </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu1.save(editedItem.todate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu> -->
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="12" md="2">
          <v-btn class="button" @click="fetchLeaveTransactions()">Fetch</v-btn>
          <!--:disabled="!valid"-->
        </v-col>
      </v-row>
    </v-card>

    <div>
      <!-- export btn code -->

      <v-col cols="12" sm="3" md="3" v-if="leave_transaction_report_list != null">
        <!-- <v-btn color="success" dark class="exportbtn" outlined rounded>
          <download-excel
            class="mar"
            :data="leave_transaction_report_list"
            :fields="table_fields"
            worksheet="LeaveTransaction_Report"
            name="LeaveTransaction_Report.xls"
          >
            <v-icon dark>mdi-file-excel</v-icon> Export
          </download-excel>
        </v-btn> -->
        <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'LeaveTransactionReport')"
          :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
      </v-col>
      <!-- export btn code end-->
      <div id="my-table-id">
        <v-data-table :headers="headers" :items="leave_transaction_report_list" class="elevation-1 box mytable"
          :search="search">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
          </v-text-field>

          <template v-slot:item.is_load_adjustment_done="{ item }">
            <span v-if="item.is_load_adjustment_done">
              <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>

          <template v-slot:item.leaveapprovalstatus="{ item }">
            <div>
              <v-btn class="ma-2" tile outlined color="success" @click="showDetails(item)">
                {{ item.leaveapprovalstatus }}
              </v-btn>
            </div>
          </template>
          <template v-slot:item.file="{ item }">
            <span v-if="item.file == 'YES'">
              <a class="p-2" :href="aws_path + item.filepath" target="blank">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-if="item.filepath !== null" v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-eye</v-icon></v-btn>
                  </template>
                  <span> View File!!! </span>
                </v-tooltip>
              </a>
            </span>
            <span v-if="item.file == 'NO'"> -- </span>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-row justify="center" dense v-if="emp_approval_details != ''">
      <v-dialog v-model="dialog" persistent max-width="1500">
        <v-card>
          <v-col cols="12" sm="12" md="12">
            <v-card class="box">
              <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Leave Details</v-toolbar-title>
              </v-toolbar>
              <v-col cols="12" sm="12" md="12">
                <v-simple-table dense class="elevation-1">
                  <thead>
                    <tr>
                      <td>From Date</td>
                      <td>To Date</td>
                      <td>Application Date</td>
                      <td>Number Of Days</td>
                      <td>Number Of Hours</td>
                      <td>Reason</td>
                      <td>Is Load Adjustment Done</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ emp_approval_details[0].fromdate }}</td>
                      <td>{{ emp_approval_details[0].todate }}</td>
                      <td>{{ emp_approval_details[0].application_date }}</td>
                      <td>{{ emp_approval_details[0].numberofdays }}</td>
                      <td>{{ emp_approval_details[0].number_of_hours }}</td>
                      <td>{{ emp_approval_details[0].reason }}</td>
                      <td>
                        <span v-if="emp_approval_details[0].is_load_adjustment_done">YES</span>
                        <span v-else>NO</span>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-simple-table dense class="elevation-1">
                  <thead>
                    <tr>
                      <td>Alternate Arrangement Person Name</td>
                      <td>Alternate Arrangement Person Contact Number</td>
                      <td>Nature Of Work</td>
                      <td>Place Of Work</td>
                      <td>Email</td>
                      <td>Mobile</td>
                      <td>Medical Certificate / Other Document</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{
                        emp_approval_details[0]
                        .alternate_arragement_person_name
                        }}
                      </td>
                      <td>
                        {{
                        emp_approval_details[0].alternate_arragement_person_no
                        }}
                      </td>
                      <td>{{ emp_approval_details[0].nature_of_work }}</td>
                      <td>{{ emp_approval_details[0].place_of_work }}</td>
                      <td>{{ emp_approval_details[0].email }}</td>
                      <td>
                        {{ emp_approval_details[0].contact_phone_number }}
                      </td>
                      <td>
                        <span v-if="
                            emp_approval_details[0].certificate_file_name !=
                            'NA'
                          ">
                          <a class="p-2" :href="
                              aws_path +
                              emp_approval_details[0].filepath +
                              emp_approval_details[0].filename
                            " target="blank">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                  <v-icon color="black">mdi-eye</v-icon></v-btn>
                              </template>
                              <span>
                                View Certificate / Other Document File!!!
                              </span>
                            </v-tooltip>
                          </a>
                        </span>
                        <span v-else>
                          {{ emp_approval_details[0].certificate_file_name }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-data-table :headers="headers1" :items="emp_approval_details[0].emp_approval"
                  class="mytable elevation-1" dense>
                </v-data-table>
              </v-col>
            </v-card>
          </v-col>
          <v-row justify="center" dense>
            <v-btn class="button" @click="dialog = false">Close</v-btn>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    extraBreadcrumbItems: [


    ],
    breadcrumbClass: "breadcrumb-style1",
    valid: false,
    overlay: false,
    errorMsg: {
      castId: false,
    },
    menu: "",
    menu1: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,

    table_fields: {
      // "Sr. No": "count",
      "Employee Name": "instructor",
      "Leave Type": "leavetype",
      "Application Date": "applicationdate",
      "From Date": "fromdate",
      "To Date": "todate",
      Days: "numberofdays",
      Hours: "number_of_hours",
      Reason: "reason",
      "Is Load Adjustment Done?": "is_load_adjustment_done",
      "Alternate Arrangement Person": "alternate_arragement_person_name",
      "Alternate Person Contact": "contact_phone_number",
      "Nature Of Work": "nature_of_work",
      "Place Of Work": "place_of_work",
      "Approval Status": "leaveapprovalstatus",
      Remark: "remark",
    },
    headers: [
      {
        text: "Employee Code",
        align: "left",
        sortable: false,
        value: "instructor",
      },
      {
        text: "Employee Name",
        align: "left",
        sortable: false,
        value: "instructor_name",
      },
      {
        text: "Leave Type",
        align: "left",
        sortable: false,
        value: "leavetype",
      },
      {
        text: "Application Date",
        align: "left",
        sortable: false,
        value: "applicationdate",
      } /*
        {
          text: 'Number Of Days',
          align: 'left',
          sortable: false,
          value: 'numberofdays',
        }, */,
      {
        text: "From Date",
        align: "left",
        sortable: false,
        value: "fromdate",
      },
      {
        text: "To Date",
        align: "left",
        sortable: false,
        value: "todate",
      },
      {
        text: "Days",
        align: "left",
        sortable: false,
        value: "numberofdays",
      },
      {
        text: "Hours",
        align: "left",
        sortable: false,
        value: "number_of_hours",
      },
      {
        text: "Reason",
        align: "left",
        sortable: false,
        value: "reason",
      },
      {
        text: "Is Load Adjustment Done?",
        align: "left",
        sortable: false,
        value: "is_load_adjustment_done",
      },
      {
        text: "Alternate Arrangement Person",
        align: "left",
        sortable: false,
        value: "alternate_arragement_person_name",
      },
      {
        text: "Alternate Person Contact",
        align: "left",
        sortable: false,
        value: "contact_phone_number",
      },
      {
        text: "File / Certificate",
        align: "left",
        sortable: false,
        value: "file",
      },
      {
        text: "Nature Of Work",
        align: "left",
        sortable: false,
        value: "nature_of_work",
      },
      {
        text: "Place Of Work",
        align: "left",
        sortable: false,
        value: "place_of_work",
      },
      {
        text: "Approval Status",
        align: "left",
        sortable: false,
        value: "leaveapprovalstatus",
      },
      {
        text: "Approval Date",
        align: "left",
        sortable: false,
        value: "approved_date",
      },
      {
        text: "Remark",
        align: "left",
        sortable: false,
        value: "remark",
      },
    ],
    headers1: [
      { text: "Sr. No", value: "srno", sortable: false },
      { text: "Authority", value: "authority", sortable: false },
      { text: "Authority Name", value: "authority_name", sortable: false },
      {
        text: "Date Of Application",
        value: "application_push_date",
        sortable: false,
      },
      {
        text: "Date Of Approval",
        value: "application_action_date",
        sortable: false,
      },
      { text: "Status", value: "status", sortable: false },
      { text: "Remark", value: "remark", sortable: false },
    ],
    emp_approval_details: [],
    leave_academic_year_list: [],
    leave_type_list: [],
    leave_approval_status_list: [],
    employee_list: [],
    leave_transaction_report_list: [],
    aws_path: null,
    editedItem: {
      leaveacademicyear: "",
      leavetype: null,
      leaveapprovalstatus: null,
      employee: null,
      fromdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      todate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    },
  }),

  mounted() {
    this.onLoad();
  },
  methods: {
      fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
    showDetails(item) {
      //window.alert(JSON.stringify(item))
      this.dialog = true;
      const formData = {
        emp_leave_transaction_id: item.id,
      };
      axios
        .post("/LeaveManagement/getEmployeeLeaveDetails", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.emp_approval_details = res.data.emp_transaction_list;
            this.aws_path = res.data.aws_path;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    fetchLeaveTransactions() {
      /*
            ||
            this.editedItem.fromdate == '' || 
            this.editedItem.todate == ''
            */
      this.overlay = true;
      if (
        this.editedItem.leaveacademicyear == "" ||
        this.editedItem.leavetype == "" ||
        this.editedItem.employee == "" ||
        this.editedItem.leaveapprovalstatus == ""
      ) {
        this.showSnackbar("#b71c1c", "Please Fill All The Fields"); // show snackbar
      } else {
        axios
          .post(
            "/LeaveManagement/fetchLeaveTransactionReports",
            this.editedItem
          )
          .then((res) => {
            if (res.data.msg == "200") {
              if ((this.load = true)) {
                this.overlay = false;
                this.leave_transaction_report_list =
                  res.data.leave_transaction_report_list;
                this.aws_path = res.data.aws_path;
              }
            } else if (res.data.msg == "NDF") {
              this.showSnackbar("#b71c1c", "No Data Found");
              this.onLoad(); //Fetch Trasnaction of All Employees
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            //window.console.log("Errro------>"+error);
          })
          .finally(() => {
            var overlay = false;
          });
      }
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/LeaveManagement/getLeaveTransactionData")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.leave_academic_year_list = res.data.leave_academic_year_list;
              this.leave_type_list = res.data.leave_type_list;
              this.leave_approval_status_list =
                res.data.leave_approval_status_list;
              this.employee_list = res.data.employee_list;
              this.leave_transaction_report_list =
                res.data.leave_transaction_report_list;
              this.editedItem.leaveacademicyear = res.data.clay;
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          //window.console.log("Errro------>"+error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
input[type="date"] {
  width: 100%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}

.tc-title {
  background-image: linear-gradient(-90deg, #fff, blue);
  color: #fff;
  border-radius: 3px;
}

.table-head {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white !important;
}
.textcolor {
  color: darkblue;
  font-weight: bold;
}
td,
th {
  border: 1px solid #ccc;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}
td {
  font-weight: bold;
}
td {
  margin: 1rem !important;
  padding: 1rem !important;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
  }
  td + td,
  th + th {
    width: auto;
  }
}
sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

.v-card__title {
  border: 1px solid #80808040;
  font-weight: bold;
  background-color: #424093;
  color: white;
  text-align: center;
  /* margin-top: 1.5rem; */
}
.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  /* padding: 5px; */
  /* margin: 1rem !important; */
  width: auto;
}

.tx-bold {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

i {
  font-size: 26px;
  cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #424093 !important;
  color: white !important;
  margin-top: 2.35rem;
  border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {
}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}

v-simple-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: auto;
  border: 1px solid #ddd;
}

th {
  color: white;
  font-weight: bold;
  text-align: center !important;
}

td,
th {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: center;
}
@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}

@media all and (min-width: 1000px) {
  .padding-metting {
    padding-right: 22px;
  }
}
@media (min-width: 320px) and (max-width: 350px) {
  .padding-bot {
    font-size: 11.6px;
  }
}
@media (min-width: 1000px) and (max-width: 1050px) {
  .padding-bot {
    font-size: 9.6px;
  }
}
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
</style>
